import theme from 'components/theme'
import {
  ColorType,
  FontSizeType,
  InputSizeType,
  ScreenWidthType,
  SectionSizeType,
  ThemePropsType,
  TransitionSpeedType
} from 'components/types'
import sortBy from 'lodash/sortBy'

const color =
  (name: ColorType) =>
  ({ theme }: ThemePropsType): string =>
    theme.palette[name]

const fontSize =
  (name: FontSizeType) =>
  ({ theme }: ThemePropsType): string =>
    theme.fontSizes[name]

const sectionSize =
  (name: SectionSizeType) =>
  ({ theme }: ThemePropsType): string =>
    theme.sectionSizes[name]

const transition =
  (name: TransitionSpeedType) =>
  ({ theme }: ThemePropsType): string =>
    theme.transition[name]

const zIndex =
  (idx: number) =>
  ({ theme }: ThemePropsType): number =>
    theme.zIndex[idx]

const stripUnit = (value: string) => {
  const unitlessValue = parseFloat(value)

  if (Number.isNaN(unitlessValue)) {
    return 0
  }

  return unitlessValue
}

const isCompact = (width: void | ScreenWidthType) => width === 'xs' || width === 'sm'

const px = (unit: number | string) => {
  const baseSize = stripUnit(theme.baseFontSize)

  if (typeof unit === 'number') {
    return `${unit * baseSize}px`
  }

  return `${stripUnit(unit) * baseSize}px`
}

const screenWidthPx = sortBy(
  Object.keys(theme.screenWidth).map((key) => ({
    key,
    width: stripUnit(px(theme.screenWidth[key]))
  })),
  ['width']
)

const inputSize =
  (name: InputSizeType) =>
  (props: ThemePropsType): string =>
    props.theme.inputSizes[name]

const screenWidth =
  (name: ScreenWidthType) =>
  (props: ThemePropsType): string =>
    props.theme.screenWidth[name]

const screenWidthLookup = (rect: ClientRect): ScreenWidthType => {
  const size =
    screenWidthPx.find((screen) => rect.width <= screen.width) ||
    screenWidthPx[screenWidthPx.length - 1]

  return size.key as ScreenWidthType
}

const themeFx = (key: keyof typeof theme) => (props: ThemePropsType) => props.theme[key] as string

export {
  color,
  fontSize,
  inputSize,
  isCompact,
  px,
  screenWidth,
  screenWidthLookup,
  sectionSize,
  stripUnit,
  themeFx as theme,
  transition,
  zIndex
}
